__webpack_require__.p = "https://outpatient.his.nhatquang.tech/";